import { formatPesoAmount } from '../utils/money';
import React from 'react';
import { formatScaleWeight } from '../utils/scalePresentation';

const formatMoney = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '--';
  return `$${formatPesoAmount(amount)}`;
};

const resolveSubtotal = (weightKg, unitPrice, allowZeroAmount = false) => {
  const normalizedWeight = Number(weightKg);
  const normalizedPrice = Number(unitPrice);
  if (!Number.isFinite(normalizedWeight) || normalizedWeight < 0) return null;
  if (!allowZeroAmount && normalizedWeight <= 0) return null;
  if (!Number.isFinite(normalizedPrice) || normalizedPrice <= 0) return null;
  return Math.floor(normalizedWeight * normalizedPrice);
};

const ScaleWeighingSummary = ({
  weightKg,
  unitPrice,
  subtotal: explicitSubtotal,
  className = '',
  cardClassName = 'rounded-2xl bg-white/60 px-4 py-3',
  amountTitle = 'Peso',
  amountLabel,
  priceTitle = 'Precio',
  subtotalTitle = 'Subtotal',
  allowZeroAmount = false,
  emptyValues = false,
  valueClassName = 'mt-1 text-lg font-bold',
}) => {
  const emptyValueLabel = '\u00a0';
  const subtotal = emptyValues ? null : explicitSubtotal === undefined
    ? resolveSubtotal(weightKg, unitPrice, allowZeroAmount)
    : explicitSubtotal != null && Number.isFinite(Number(explicitSubtotal)) ? Number(explicitSubtotal) : null;
  const weightLabel = emptyValues
    ? emptyValueLabel
    : amountLabel != null && amountLabel !== ''
      ? amountLabel
      : (formatScaleWeight(weightKg) || '--');
  const priceLabel = emptyValues ? emptyValueLabel : formatMoney(unitPrice);
  const subtotalLabel = emptyValues
    ? emptyValueLabel
    : subtotal == null ? '--' : formatMoney(subtotal);

  return (
    <div className={`grid grid-cols-1 gap-3 sm:grid-cols-3 ${className}`.trim()}>
      <div className={cardClassName}>
        <div className="text-[11px] font-semibold uppercase tracking-wide opacity-70">{amountTitle}</div>
        <div className={valueClassName}>{weightLabel}</div>
      </div>
      <div className={cardClassName}>
        <div className="text-[11px] font-semibold uppercase tracking-wide opacity-70">{priceTitle}</div>
        <div className={valueClassName}>{priceLabel}</div>
      </div>
      <div className={cardClassName}>
        <div className="text-[11px] font-semibold uppercase tracking-wide opacity-70">{subtotalTitle}</div>
        <div className={valueClassName}>{subtotalLabel}</div>
      </div>
    </div>
  );
};

export default ScaleWeighingSummary;
